import { render, staticRenderFns } from "./StatementDownloadButton.vue?vue&type=template&id=d0b0d9c0"
import script from "./StatementDownloadButton.vue?vue&type=script&lang=js"
export * from "./StatementDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports